import _range from 'lodash/range';
import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export default function CalendarDayHeaders(props) {
  var className = props.className,
      dayAbbrevs = props.dayAbbrevs,
      firstWeekday = props.firstWeekday,
      gutterWidth = props.gutterWidth;


  return React.createElement(
    'div',
    { className: classNames('tt-cal-dayHeaders', className) },
    _range(firstWeekday, firstWeekday + 7).map(function (weekday, idx) {
      return React.createElement(
        'div',
        {
          key: weekday % 7,
          className: 'tt-cal-columnHeader',
          style: {
            marginLeft: idx === 0 ? null : gutterWidth
          }
        },
        dayAbbrevs[weekday % 7]
      );
    })
  );
}

CalendarDayHeaders.propTypes = {
  className: PropTypes.string,
  dayAbbrevs: PropTypes.arrayOf(PropTypes.string).isRequired,
  firstWeekday: PropTypes.number.isRequired,
  gutterWidth: PropTypes.string
};